import { render, staticRenderFns } from "./SummaryLayanan.vue?vue&type=template&id=8fbd050e&scoped=true"
import script from "./SummaryLayanan.vue?vue&type=script&lang=js"
export * from "./SummaryLayanan.vue?vue&type=script&lang=js"
import style0 from "./SummaryLayanan.vue?vue&type=style&index=0&id=8fbd050e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbd050e",
  null
  
)

export default component.exports